import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './src/App';

import Uploader from './uploader';
import UsageComponent from './usage';
import SubscriptionsComponent from './settings/subscriptions';
import NotificationsComponent from './notifications';
import EndpointsComponent from './endpoints';

const element = document.getElementById('file-sender-app');

if (element) {

    let checkUrl = element.getAttribute('data-check-url');
    let downloadUrl = element.getAttribute('data-download-url');

    createRoot(element).render(
        <App checkUrl={checkUrl} downloadUrl={downloadUrl} />
    );
}

const uploaderElement = document.getElementById('file-sender-uploader');

if (uploaderElement) {

    let uploadUrl = uploaderElement.getAttribute('data-upload-url');

    createRoot(uploaderElement).render(<Uploader uploadUrl={uploadUrl} />);
}

const usageElement = document.getElementById('usage-component');

if (usageElement) {
    createRoot(usageElement).render(<UsageComponent />);
}

const subscriptionsSettingsElement = document.getElementById('subscriptions-settings-component');

if (subscriptionsSettingsElement) {
    createRoot(subscriptionsSettingsElement).render(<SubscriptionsComponent />);
}

const notificationsElement = document.getElementById('notifications-component');

if (notificationsElement) {
    createRoot(notificationsElement).render(<NotificationsComponent />);
}

const endpointsElement = document.getElementById('endpoints-component');

if (endpointsElement) {
    createRoot(endpointsElement).render(<EndpointsComponent />);
}
